import React, { Component } from 'react';
import '../style.scss';

class CrawlerStart extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        let tempText;
        if (!this.props.data.crawlerStatus || this.props.data.crawlerStatus.length <= 0 || this.props.data.crawlerStatus === 'START') {
            tempText = <i className="fa fa-play-circle crawler-status-icon text-primary" onClick={() => this.props.handleCrawlers(this.props.data, true)}></i>
        } else if (this.props.data.crawlerStatus === 'SUCCESS') {
            tempText = <i className="fa fa-check-circle crawler-status-icon text-success" title={this.props.data.failureReason} onClick={() => this.props.handleCrawlers(this.props.data, true)}></i>
        } else if (this.props.data.crawlerStatus === 'FAILURE') {
            tempText = <i className="fa fa-times-circle crawler-status-icon text-danger" title={this.props.data.failureReason} onClick={() => this.props.handleCrawlers(this.props.data, true)}></i>
        } else if (this.props.data.crawlerStatus === 'PARTIAL_FAILURE') {
            tempText = <i className="fa fa-exclamation-triangle crawler-status-icon text-warning" title={this.props.data.failureReason} onClick={() => this.props.handleCrawlers(this.props.data, true)}></i>
        } else if (this.props.data.crawlerStatus === 'INPROGRESS') {
            tempText = <i className="fa fa-spinner crawler-status-icon text-warning" title={this.props.data.failureReason} onClick={() => this.props.handleCrawlers(this.props.data, true)}></i>
        }
        return (
            <div>{(this.props.data.crawlerFlag) ? tempText : ''}</div>
        )
    }
}
export default CrawlerStart